import AvatarChip from './AvatarChip';

export function AssignedResourceChip({ name }: { name: string }) {
  return <AvatarChip personName={name || ''} />;
}
